(function ($, Cobalt, undefined) {
    Cobalt.CPSkinManager =
    {
        initialize: function () {
            this.toggleDefaultSkin();
            this.toggleSkinOptions();
        },
        toggleDefaultSkin: function () {
            $("#field-skins").on("click", ".default-skin", function() {
                var $that = $(this);
                var isSelected = $that.hasClass("selected");
                $(".default-skin").removeClass("selected");

                if (!isSelected) {
                    $that.addClass("selected");
                    $("#field-default-skin").val($that.attr("data-id"));
                }
            });
        },
        toggleSkinOptions: function () {
            $("#field-skins").on("change", "input.j-skin", function() {
                var $that = $(this);
                if ($that.is(":checked")) {
                    $that.parents("li.j-skin").find(".j-skin-roles,.j-default-skin").removeClass('hide');
                } else {
                    $that.parents("li.j-skin").find(".j-skin-roles,.j-default-skin").addClass('hide');
                }
            });
        }
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.CPSkinManager.js